import { render, staticRenderFns } from "./change-user-password.vue?vue&type=template&id=ac0872ce&"
import script from "./change-user-password.vue?vue&type=script&lang=js&"
export * from "./change-user-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports